import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'

import { howItWorksTimelineContent } from './how-it-works-timeline.content'
import classes from './how-it-works-timeline.module.scss'
import { CONFIG } from '../../config'
import IconDelivery from '../../static/images/simVertical.svg'
import IconActivate from '../../static/images/timeline-calendar.svg'
import IconFree from '../../static/images/timeline-free.svg'
import IconTransfer from '../../static/images/timeline-transfer.svg'
import TimelineBg from '../../static/images/timeline.svg'
import { FourColumn } from '../shared'

interface HowItWorksTimelineProps {
  plan?: { plan_is_data_only?: boolean }
}

export const HowItWorksTimeline: FC<HowItWorksTimelineProps> = ({ plan }) => (
  <>
    <Typography
      component="h2"
      variant="Kollektif/ExtraLarge"
      className={classes.title}
    >
      {howItWorksTimelineContent.title}
    </Typography>
    <ol
      className={classes.timeline}
      style={{ '--timeline-bg': `url(${TimelineBg})` } as React.CSSProperties}
    >
      <li className={classes.step}>
        <Typography
          component="h3"
          variant="Kollektif/MediumEmphasis"
          className={classes.stepHeading}
        >
          <img
            className={classes.icon}
            src={IconDelivery}
            alt=""
            loading="lazy"
            decoding="async"
          />
          <span>
            {howItWorksTimelineContent.simArrives}
            {howItWorksTimelineContent.eSim}
          </span>
        </Typography>
      </li>
      <li className={classes.step}>
        <Typography
          component="h3"
          variant="Kollektif/MediumEmphasis"
          className={classes.stepHeading}
        >
          <img
            className={classes.icon}
            src={IconActivate}
            alt=""
            loading="lazy"
            decoding="async"
          />
          <span>{howItWorksTimelineContent.activate}</span>
        </Typography>
      </li>
      {plan && !plan.plan_is_data_only && (
        <li className={classes.step}>
          <Typography
            component="h3"
            variant="Kollektif/MediumEmphasis"
            className={classes.stepHeading}
          >
            <img
              className={classes.icon}
              src={IconTransfer}
              alt=""
              loading="lazy"
              decoding="async"
            />
            <span>{howItWorksTimelineContent.transfer}</span>
          </Typography>
        </li>
      )}
      <li className={classes.step}>
        <Typography
          component="h3"
          variant="Kollektif/MediumEmphasis"
          className={classes.stepHeading}
        >
          <img
            className={classes.icon}
            src={IconFree}
            alt=""
            loading="lazy"
            decoding="async"
          />
          <span>
            {howItWorksTimelineContent.referral(CONFIG.RAF_VOUCHER_VALUE)}
          </span>
        </Typography>
      </li>
    </ol>
  </>
)

export const HowItWorksSteps: FC<HowItWorksTimelineProps> = ({ plan }) => (
  <>
    <Typography
      component="h2"
      variant="Kollektif/ExtraLarge"
      className={classes.title}
    >
      {howItWorksTimelineContent.title}
    </Typography>
    <FourColumn className={classes.stepsContainer}>
      <div className={classes.whyCard}>
        <img
          className={classes.largeIcon}
          src={IconDelivery}
          alt=""
          loading="lazy"
          decoding="async"
        />
        <Typography
          component="h3"
          variant="Kollektif/MediumEmphasis"
          className={classes.whyCardTitle}
        >
          {howItWorksTimelineContent.simArrives}
          {howItWorksTimelineContent.eSim}
        </Typography>
      </div>
      <div className={classes.whyCard}>
        <img
          className={classes.largeIcon}
          src={IconActivate}
          alt=""
          loading="lazy"
          decoding="async"
        />
        <Typography
          component="h3"
          variant="Kollektif/MediumEmphasis"
          className={classes.whyCardTitle}
        >
          {howItWorksTimelineContent.activate}
        </Typography>
      </div>
      {plan && !plan.plan_is_data_only && (
        <div className={classes.whyCard}>
          <img
            className={classes.largeIcon}
            src={IconTransfer}
            alt=""
            loading="lazy"
            decoding="async"
          />
          <Typography
            component="h3"
            variant="Kollektif/MediumEmphasis"
            className={classes.whyCardTitle}
          >
            {howItWorksTimelineContent.transfer}
          </Typography>
        </div>
      )}
      <div className={classes.whyCard}>
        <img
          className={classes.largeIcon}
          src={IconFree}
          alt=""
          loading="lazy"
          decoding="async"
        />
        <Typography
          component="h3"
          variant="Kollektif/MediumEmphasis"
          className={classes.whyCardTitle}
        >
          {howItWorksTimelineContent.referral(CONFIG.RAF_VOUCHER_VALUE)}
        </Typography>
      </div>
    </FourColumn>
  </>
)
